// extracted by mini-css-extract-plugin
export default {"root":"Divider_root__3vrjq"};